const httpRegEx =
  /^\w[\w\-_.]+\.(co|uk|com|org|net|gov|biz|info|online|shop|store|us|eu|de|ch|at|fr|it|es|cat|pt|pl|cz|au|nz|fi|se|dk|nl|no|ie|ru|br|mx|cloud)/i

const unwantedParams = [
  'preview',
  'previewTheme',
  'previewThemeSettings',
  'shop',
  'language',
  'token',
  'themeTitle',
  'isNowPreview',
]

export function formatHref(href) {
  if (!href) return ''

  // we have no valid use case for entering `javascript:` or `data:` links
  // except for javascript:gaOptout()
  let sanitizedString = href
    .trim()
    .replace(/^\s*(data|javascript)\s*:(?!(gaOptout|matomoOptout)\(\))/i, '')
    .replace(/\s+/g, '') // Remove spaces from the entire link

  // convert same origin links to root-relative ones, while also stripping the `editor` part and harmful query parameters
  const url = new URL(sanitizedString, 'https://example.com')
  if (url.origin === location.origin) {
    for (const param of unwantedParams) url.searchParams.delete(param)
    sanitizedString = url.href.substring(url.origin.length)
    sanitizedString = sanitizedString.replace(/^\/editor/, '')

    return sanitizedString
  }

  // Try to catch common cases of users forgetting to add "http://" in front,
  // but err on the safe side: if it looks even remotely like a hostname, just stop.
  // Feel free to add your favourite contry's TLD as long as it is not a common file extension.
  else return sanitizedString.match(httpRegEx) ? 'http://' + sanitizedString : sanitizedString
}
